import React, { useState } from 'react';
import { Phone, Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import { companyInfo } from '../mockData';

const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <nav className="bg-white shadow-md sticky top-0 z-40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-24">
          {/* Logo */}
          <div className="flex items-center">
            <img 
              src="/greva-logo.svg" 
              alt="Greva Electric Logo" 
              className="h-20 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <button onClick={() => scrollToSection('home')} className="text-gray-700 hover:text-teal-600 font-medium transition-colors">
              Home
            </button>
            <button onClick={() => scrollToSection('services')} className="text-gray-700 hover:text-teal-600 font-medium transition-colors">
              Services
            </button>
            <button onClick={() => scrollToSection('about')} className="text-gray-700 hover:text-teal-600 font-medium transition-colors">
              About Us
            </button>
            <button onClick={() => scrollToSection('testimonials')} className="text-gray-700 hover:text-teal-600 font-medium transition-colors">
              Reviews
            </button>
          </div>

          {/* Phone and CTA */}
          <div className="hidden md:flex items-center space-x-4">
            <a href={`tel:${companyInfo.phone}`} className="flex items-center text-teal-600 font-semibold text-lg hover:text-teal-700 transition-colors">
              <Phone className="mr-2" size={20} />
              {companyInfo.phone}
            </a>
            <Button 
              onClick={() => window.location.href = `tel:${companyInfo.phone}`}
              className="bg-teal-500 hover:bg-teal-600 text-white font-semibold px-6 py-2 rounded-md transition-colors"
            >
              Call Now
            </Button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="text-gray-700 hover:text-cyan-500"
            >
              {mobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-white border-t">
          <div className="px-4 py-4 space-y-3">
            <button onClick={() => scrollToSection('home')} className="block w-full text-left py-2 text-gray-700 hover:text-teal-600 font-medium">
              Home
            </button>
            <button onClick={() => scrollToSection('services')} className="block w-full text-left py-2 text-gray-700 hover:text-teal-600 font-medium">
              Services
            </button>
            <button onClick={() => scrollToSection('about')} className="block w-full text-left py-2 text-gray-700 hover:text-teal-600 font-medium">
              About Us
            </button>
            <button onClick={() => scrollToSection('testimonials')} className="block w-full text-left py-2 text-gray-700 hover:text-teal-600 font-medium">
              Reviews
            </button>
            <a href={`tel:${companyInfo.phone}`} className="flex items-center py-2 text-teal-600 font-semibold">
              <Phone className="mr-2" size={20} />
              {companyInfo.phone}
            </a>
            <Button 
              onClick={() => window.location.href = `tel:${companyInfo.phone}`}
              className="w-full bg-teal-500 hover:bg-teal-600 text-white font-semibold py-2 rounded-md"
            >
              Call Now
            </Button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;